import React from 'react';
import { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

import AutosuggestText from 'ui/AutosuggestText';
import { isValidEmail } from 'utils/validators';
import RecipientsList from './RecipientsList';

import {
    Table,
    TableRow,
    TableCell,
    TableHead,
    Select,
    OutlinedInput,
} from '@material-ui/core';
import permissionsOptions from '../permissions';

const styles = theme => ({
    container: {
        display: 'flex',
        flexWrap: 'wrap',
        width: '100%',
        paddingTop: '20px',
    },

    info: {
        flex: 1,
    },

    noBorder: {
        borderBottom: 0,
    },
    autoSuggest: {
        marginBottom: 0,
    },
});

const AddRecipients = props => {
    const {
        newRecipientsInfo,
        currentShare,
        onAddRecipient,
        onChangePermission,
        onRemoveRecipient,
        classes,
    } = props;

    const [newRecipientInfo, setNewRecipientInfo] = useState({
        permissions: 'editor',
    });

    const [error, setError] = useState(false);

    const renderInputComponent = inputProps => {
        const { classes, inputRef = () => {}, ref, ...other } = inputProps;

        return (
            <>
                <TextField
                    required
                    label="Enter group or recipient name"
                    className={classes.autoSuggest}
                    margin="normal"
                    variant="outlined"
                    fullWidth
                    error={error}
                    helperText={error && "Group doesn't exist"}
                    InputProps={{
                        inputRef: node => {
                            ref(node);
                            inputRef(node);
                        },
                    }}
                    {...other}
                />
            </>
        );
    };

    const cleanUpForm = () => {
        setNewRecipientInfo({
            name: '',
            permissions: 'editor',
        });
        setError(false);
    };

    const addNewRecipient = () => {
        const selected = currentShare.available_recipients.find(
            i => i.display_name === newRecipientInfo.name
        );
        if (selected) {
            onAddRecipient({
                display_name: selected.display_name,
                name: selected.name,
                type: selected.type,
                permissions: newRecipientInfo.permissions,
                uuid: selected.uuid,
            });
            cleanUpForm();
        } else if (isValidEmail(newRecipientInfo.name)) {
            onAddRecipient({
                display_name: newRecipientInfo.name,
                name: newRecipientInfo.name,
                permissions: newRecipientInfo.permissions,
                type: 'invitation',
            });
            cleanUpForm();
        } else {
            setError(true);
        }
    };

    const selectRecipient = val => {
        setNewRecipientInfo({
            ...newRecipientInfo,
            name: val,
        });
        if (val === '') {
            setError(false);
        }
    };

    const selectPermission = (prop, val) => {
        setNewRecipientInfo({
            ...newRecipientInfo,
            permissions: val.props.value,
        });
    };

    const existing = new Set(newRecipientsInfo.map(r => r.name));
    const availableRecipients = currentShare.available_recipients.filter(
        r => !existing.has(r.name)
    );

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell
                            style={{
                                width: '531px',
                                fontWeight: 'bold',
                            }}
                        >
                            Recipient
                        </TableCell>
                        <TableCell
                            style={{
                                minWidth: '200px',
                                fontWeight: 'bold',
                            }}
                        >
                            Permission
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell className={classes.noBorder}>
                            <AutosuggestText
                                renderInputComponent={renderInputComponent}
                                value={newRecipientInfo.name}
                                suggestions={availableRecipients.map(item => ({
                                    label: item.display_name,
                                }))}
                                onChange={selectRecipient}
                            />
                        </TableCell>
                        <TableCell className={classes.noBorder}>
                            <Select
                                style={{
                                    minWidth: '241px',
                                }}
                                value={newRecipientInfo.permissions}
                                input={
                                    <OutlinedInput
                                        labelWidth={0}
                                        name="permissions"
                                        id="outlined-age-native-simple"
                                    />
                                }
                                onChange={selectPermission}
                            >
                                {permissionsOptions.map((permission, index) => (
                                    <MenuItem
                                        key={index}
                                        value={permission.key}
                                    >
                                        {permission.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            <Typography className={classes.info}>
                                After adding users click Save at the bottom
                            </Typography>
                        </TableCell>
                        <TableCell>
                            <Button
                                style={{ float: 'right' }}
                                color="secondary"
                                variant="contained"
                                disabled={!newRecipientInfo.name}
                                onClick={addNewRecipient}
                            >
                                Add
                            </Button>
                        </TableCell>
                    </TableRow>
                </TableHead>
            </Table>

            {newRecipientsInfo.length > 0 && (
                <div className={classes.container}>
                    <RecipientsList
                        recipients={newRecipientsInfo}
                        permissionsOptions={permissionsOptions}
                        onChange={onChangePermission}
                        onRemove={onRemoveRecipient}
                        maxHeight={240}
                    />
                </div>
            )}
        </>
    );
};

export default withStyles(styles)(AddRecipients);
